import React from 'react';
import { string, func } from 'prop-types';
import { surveySchemaPartType } from '../../../constants/types';
import { getTranslation } from '../../../i18n';
import SchemaPartItemPreview from '../../Preview/SchemaPartPreview/SchemaPartItemPreview';

const buildQuestionOrderById = (items) => {
  let counter = 1;
  return items.reduce((acc, item) => {
    if (item.questionGroup) {
      item.questionGroup.questions.reduce((ac, question) => {
        ac[question.code] = counter;
        counter += 1;
        return ac;
      }, acc);
    } else if (item.question) {
      acc[item.question.code] = counter;
      counter += 1;
    }
    return acc;
  }, {});
};

const Questions = ({ surveyPart, lang, translate }) => {
  const renderSchemaPartItem = (item, index, questionOrderNumById) => (
    <li key={item.order}>
      <SchemaPartItemPreview
        item={item}
        questionOrder={questionOrderNumById}
        lang={lang}
        translate={translate}
      />
    </li>
  );

  const title = getTranslation(surveyPart.title, lang);
  const items = surveyPart.surveySchemaPartItems;
  const questionOrderNumById = buildQuestionOrderById(items);
  return (
    <div>
      <h1>{title}</h1>
      <ul>
        {items.map((item, idx) => renderSchemaPartItem(item, idx, questionOrderNumById))}
      </ul>
    </div>
  );
};

Questions.propTypes = {
  surveyPart: surveySchemaPartType.isRequired,
  lang: string.isRequired,
  translate: func.isRequired
};

export default Questions;
